import { render, staticRenderFns } from "./paygentStatusModal.vue?vue&type=template&id=06be1f1c&"
import script from "./paygentStatusModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./paygentStatusModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports